module.exports = __webpack_public_path__ + "img/click.673068c2.png";